// ADR 7.10.26w §5 — which companion surface is in front. Pure.
//
// Roadmap 7.10.26t §3's priority: the last opened is in front, the switcher's
// choice wins, and closing the front surface brings the other forward. The
// default front is the tutor, because a reload restores an open dock and never
// a card.

export type Front = 'tutor' | 'app_card'
export type Shown = Front | 'rest'
export type FrontChange = 'tutor_opened' | 'card_shown' | 'switched_to_tutor' | 'switched_to_card'

const AFTER: Record<FrontChange, Front> = {
  tutor_opened: 'tutor',
  card_shown: 'app_card',
  switched_to_tutor: 'tutor',
  switched_to_card: 'app_card',
}

/**
 * The front after one change. Every change names its surface, so the answer
 * does not depend on `front`; it is taken so a caller reads as a transition.
 */
export function frontAfter(front: Front, change: FrontChange): Front {
  return AFTER[change] ?? front
}

const OTHER: Record<Front, Front> = { tutor: 'app_card', app_card: 'tutor' }

export interface OpenSurfaces {
  tutor: boolean
  card: boolean
}

function isOpen(surface: Front, open: OpenSurfaces): boolean {
  return surface === 'tutor' ? open.tutor : open.card
}

/** The front if open, else the other if open, else the rest. */
export function shown(front: Front, open: OpenSurfaces): Shown {
  if (isOpen(front, open)) return front
  if (isOpen(OTHER[front], open)) return OTHER[front]
  return 'rest'
}
